import React, { Fragment } from "react";
import styles from "./styles/AIImageGen.module.css";
import { Input, Select } from "antd";
import { AspectRatioPicker } from "./PersonStudioInputs";

const { TextArea } = Input;
const OBJECT_POSITION_MAP = {
    "top half": ["bottom half"],
    "bottom half": ["top half"],
    "top right": ["bottom half", "top left"],
    "top left": ["bottom half", "top right"],
    "bottom right": ["top half", "bottom left"],
    "bottom left": ["top half", "bottom right"],
    "right half": ["left half"],
    "left half": ["right half"],
    center: ["full image except center"],
};
const IMAGE_STYLE_OPTIONS = [
    "Doodle",
    "Comic Book",
    "Line Art",
    "Illustration",
    "Low Poly",
    "3D Model",
    "Pencil Sketch Drawing",
    "Digital Abstract",
    "Watercolor",
];

function RawStudioInputs({ config, setConfig }) {
    return (
        <Fragment>
            <p className={styles.label}>Aspect Ratio</p>
            <AspectRatioPicker
                value={config.size}
                onChange={(value) => {
                    setConfig({ ...config, size: value });
                }}
            />
            {/*image style payload*/}
            <p className={styles.label}>Image Style</p>
            <Select
                placeholder="Select image style"
                style={{ width: "100%" }}
                value={config.image_style ?? null}
                onChange={(value) => {
                    setConfig({
                        ...config,
                        image_style: value,
                    });
                }}
                options={IMAGE_STYLE_OPTIONS.map((style) => ({
                    label: style,
                    value: style.toLowerCase().replace(/\s+/g, "_"),
                }))}
            />

            <p className={styles.label}>Negative Space</p>
            <Select
                placeholder="Select negative space"
                style={{ width: "100%" }}
                value={config.negative_space ?? null}
                onChange={(value) => {
                    setConfig({
                        ...config,
                        negative_space: value,
                        object_position: null, // reset
                    });
                }}
                options={[
                    { label: "Top Half", value: "top half" },
                    { label: "Bottom Half", value: "bottom half" },
                    { label: "Top Right", value: "top right" },
                    { label: "Top Left", value: "top left" },
                    { label: "Bottom Right", value: "bottom right" },
                    { label: "Bottom Left", value: "bottom left" },
                    { label: "Right Half", value: "right half" },
                    { label: "Left Half", value: "left half" },
                    { label: "Center", value: "center" },
                ]}
            />

            <p className={styles.label}>Object Position</p>
            <Select
                placeholder="Select object position"
                style={{ width: "100%" }}
                value={config.object_position ?? null}
                disabled={!config.negative_space}
                onChange={(value) => {
                    setConfig({
                        ...config,
                        object_position: value,
                    });
                }}
                options={(OBJECT_POSITION_MAP[config.negative_space] || []).map(
                    (pos) => ({
                        label: pos
                            .split(" ")
                            .map(
                                (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(" "),
                        value: pos,
                    })
                )}
            />

            <p className={styles.label}>Prompt</p>
            <TextArea
                placeholder="Enter your prompt here"
                autoSize={{ minRows: 12 }}
                style={{ width: "100%" }}
                value={config.prompt}
                onChange={(e) => {
                    setConfig({ ...config, prompt: e.target.value });
                }}
            />
        </Fragment>
    );
}

export default RawStudioInputs;
